import { useLocalStorage } from '../../hooks/useLocalStorage';
import { InteractionState } from '../../types';

interface LegendProps {
  interactionState: InteractionState;
}

export function Legend({ interactionState }: LegendProps) {
  const [isCollapsed, setIsCollapsed] = useLocalStorage('legendCollapsed', true);

  return (
    <div style={{
      position: 'absolute',
      bottom: '10px',
      left: '10px',
      zIndex: 10,
      background: 'rgba(255,255,255,0.95)',
      padding: '8px',
      borderRadius: '3px',
      fontSize: '11px',
      maxWidth: isCollapsed ? '100px' : '240px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: isCollapsed ? 0 : '6px',
        cursor: 'pointer'
      }} onClick={() => setIsCollapsed(!isCollapsed)}>
        <strong style={{ fontSize: '12px' }}>Legend</strong>
        <span style={{
          fontSize: '14px',
          marginLeft: '8px',
          transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
          display: 'inline-block'
        }}>▾</span>
      </div>
      
      {!isCollapsed && (
        <>
          <div style={{ marginTop: '8px' }}><strong>Controls:</strong></div>
          <div>• Drag background: Pan view</div>
          <div>• Drag nodes: Move position</div>
          <div>• Shift+Drag: Adjust values/ratings</div>
          <div>• Right-click nodes: Context menu</div>
          <div>• Right-click lines: Delete</div>
          <div>• Bottom panel: Sliders for precise control</div>
          {interactionState.mode === 'adding-node' && <div>• Click to place node</div>}
          {interactionState.mode === 'adding-edge' && <div>• Click two nodes to connect</div>}
          
          <div style={{ marginTop: '8px' }}><strong>Line Colors:</strong></div>
          <div style={{ color: '#00C800' }}>• Green: Normal (0-80%)</div>
          <div style={{ color: '#FFA500' }}>• Orange: Warning (80-100%)</div>
          <div style={{ color: '#FF0000' }}>• Red: Overloaded ({'>'}100%)</div>
        </>
      )}
    </div>
  );
}
